import basePageFields from '@fragments/pages/basePageFields';
import VideoPosterFragment from '@fragments/shared/VideoPosterFragment';
import SyndicationsFragment from '@fragments/shared/SyndicationsFragment';
import TagFragment from '@fragments/pages/TagFragment';
import SeoFragment from '@fragments/shared/SeoFragment';
import StreamContainedFragment from '@fragments/shared/StreamContainedFragment';

export default gql`
    fragment VideoFragment on Video {
        ${basePageFields}
        contributors {
            firstName
            lastName
            middleName
            title
        }
        dek
        video {
            ...VideoPosterFragment
        }
        syndications {
            ...SyndicationsFragment
        }
        tags {
            ...TagFragment
        }
        seo {
            ...SeoFragment
        }
        streamContained {
            ...StreamContainedFragment
        }
    }
    ${VideoPosterFragment}
    ${SyndicationsFragment}
    ${TagFragment}
    ${SeoFragment}
    ${StreamContainedFragment}
`;
